<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <b-row class="mb-2">
                <b-col lg="2">
                  <label class="small mb-1">Building</label>
                  <b-form-select v-model="filters.buildingId" :options="buildingOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">House</label>
                  <b-form-select v-model="filters.houseId" :options="houseOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Tenant</label>
                  <b-form-select v-model="filters.tenantId" :options="tenantOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Owner</label>
                  <b-form-select v-model="filters.userId" :options="ownerUserOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Payment Method</label>
                  <b-form-select v-model="filters.paymentMethod" :options="paymentMethodOptions" size="sm"></b-form-select>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Payment Category</label>
                  <b-form-select v-model="filters.paymentCategory" :options="paymentCategoryOptions" size="sm"></b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col lg="2">
                  <label class="small mb-1">Payment Date</label>
                  <b-form-input v-model="filters.paymentDate" type="date" size="sm"></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Transaction Ref</label>
                  <b-form-input v-model="filters.transactionRef" type="text" size="sm" placeholder="Reference..."></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Min Amount</label>
                  <b-form-input v-model.number="filters.minAmount" type="number" size="sm" placeholder="Min"></b-form-input>
                </b-col>
                <b-col lg="2">
                  <label class="small mb-1">Max Amount</label>
                  <b-form-input v-model.number="filters.maxAmount" type="number" size="sm" placeholder="Max"></b-form-input>
                </b-col>
                <b-col lg="1" class="d-flex align-items-end">
                  <b-button size="sm" variant="outline-secondary" @click="resetFilters">Reset</b-button>
                </b-col>
                <b-col lg="1" class="d-flex align-items-end">
                  <b-button-group>
                    <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" title="Export to Excel"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                    <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" title="Export to PDF"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                  </b-button-group>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col lg="3" class="my-1">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Search"></b-form-input>
                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
            
            <div class="table-container">
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th>No.</b-th>
                  <b-th>Tenant</b-th>
                  <b-th>Tenant Phone No</b-th>
                  <b-th>Building</b-th>
                  <b-th>House</b-th>
                  <b-th>Total Amount</b-th>
                  <b-th>Paid Amount</b-th>
                  <b-th>15% VAT</b-th>
                  <b-th>3% Withholding</b-th>
                  <b-th>Paid For</b-th>
                  <b-th>Paid Month</b-th>
                  <b-th>Payment Method</b-th>
                  <b-th>Date of Payment</b-th>
                  <b-th>Credit Account</b-th>
                  <b-th>Transaction Reference</b-th>
                </b-tr>
              </b-thead>
              <template v-if="spinner">
                <b-tbody class="text-center">
                  <b-tr >
                    <b-td colspan="15" class="text-center" style="display: table-cell">
                      <b-spinner
                        style="height: 3rem; width: 3rem;"
                        variant="warning"
                      ></b-spinner>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
              <template v-else>
                <b-tbody>
                  <template v-if="filterTable.length === 0">
                    <b-tr>
                      <b-td colspan="15" class="text-center">Nothing found</b-td>
                    </b-tr>
                  </template>
                  <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.payingId || index"
                    >
                      <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                      <b-td>{{getTenantName(item)}}</b-td>
                      <b-td>{{item.tenantPhoneNumber || 'N/A'}}</b-td>
                      <b-td>{{getBuildingName(item)}}</b-td>
                      <b-td>{{getHouseInfo(item)}}</b-td>
                      <b-td>{{numberWithCommas(item.totalAmount)}}</b-td>
                      <b-td>{{numberWithCommas(item.payedAmount)}}</b-td>
                      <b-td>
                        <template v-if="item.paymentCategory === 'Rent Payment'">
                          {{numberWithCommas(item.vat)}}
                        </template>
                        <template v-else>
                          0.00
                        </template>
                      </b-td>
                      <b-td>{{numberWithCommas(item.withHolding)}}</b-td>
                      <b-td>{{item.paymentCategory || 'N/A'}}</b-td>
                      <b-td>{{item.paymentForMonth || 'N/A'}}</b-td>
                      <b-td>{{item.paymentMethod || 'N/A'}}</b-td>
                      <b-td>{{formatDate(item.paymentDate)}}</b-td>
                      <b-td>{{item.creditAccount || 'N/A'}}</b-td>
                      <b-td>{{item.transactionRef || 'N/A'}}</b-td>
                    </b-tr>
                  </template>
                </b-tbody>
              </template>
            </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                    <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="displayRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import * as XLSX from 'xlsx'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    components: {
      LTable,
      Card
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        totalRows: 0,
        currentPage: 1,
        perPage: 7,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        items: [],
        allItems: [],
        filter: "",
        spinner: true,
        dataExcel: [],
        filters: {
          buildingId: null,
          houseId: null,
          tenantId: null,
          userId: null,
          paymentDate: "",
          paymentMethod: null,
          paymentCategory: null,
          paymentForMonth: "",
          transactionRef: "",
          minAmount: null,
          maxAmount: null
        },
        buildingOptions: [{value: null, text: "All Buildings"}],
        houseOptions: [{value: null, text: "All Houses"}],
        tenantOptions: [{value: null, text: "All Tenants"}],
        ownerUserOptions: [{value: null, text: "All Owners"}],
        paymentMethodOptions: [
          {value: null, text: "All Methods"},
          {value: "ios", text: "ios"},
          {value: "android", text: "android"},
          {value: "BRANCH", text: "BRANCH"},
          {value: "USSD", text: "USSD"},
        ],
        paymentCategoryOptions: [
          {value: null, text: "All Categories"},
          {value: "houseRent", text: "Rent Payment"},
          {value: "guarantyPayment", text: "Guaranty Payment"},
          {value: "penaltyPayment", text: "Penalty Payment"},
          {value: "billsPayment", text: "Bills Payment"}
        ]
      }
    },
    watch: {
      'filters.buildingId'() { this.applyFilters(); },
      'filters.houseId'() { this.applyFilters(); },
      'filters.tenantId'() { this.applyFilters(); },
      'filters.userId'() { this.applyFilters(); },
      'filters.paymentDate'() { this.applyFilters(); },
      'filters.paymentMethod'() { this.applyFilters(); },
      'filters.paymentCategory'() { this.applyFilters(); },
      'filters.paymentForMonth'() { this.applyFilters(); },
      'filters.transactionRef'() { this.applyFilters(); },
      'filters.minAmount'() { this.applyFilters(); },
      'filters.maxAmount'() { this.applyFilters(); },
      filter(val) {
        if (val && val.trim()) this.fetchAllForSearch();
        else this.allItems = [];
      }
    },
    computed: {
      searchSource() {
        return this.filter && this.allItems.length ? this.allItems : this.items;
      },
      filterTable() {
        if (!this.filter) return this.items;
        const s = this.filter.trim().toLowerCase();
        return this.searchSource.filter(item => [
          item.tenant ? item.tenant.fullName : '',
          item.tenant ? item.tenant.phoneNumber : '',
          item.tenant ? item.tenant.email : '',
          item.tenantPhoneNumber,
          item.house ? (item.house.buildingName || (item.house.building ? item.house.building.buildingName : '')) : '',
          item.house ? (item.house.location || (item.house.building ? item.house.building.location : '')) : '',
          item.house ? item.house.floor : '',
          item.house ? item.house.roomNumber : '',
          item.house ? item.house.size : '',
          item.paymentCategory,
          item.paymentMethod,
          item.paymentDate,
          item.paymentForMonth,
          item.transactionRef,
          item.creditAccount,
          item.debitAccount,
          item.totalAmount,
          item.payedAmount,
          item.vat,
          item.withHolding,
          item.rentPrice,
          item.guaranteedPrice,
          item.billsPrice,
          item.penaltyPrice
        ].some(v => v !== null && v !== undefined && String(v).toLowerCase().includes(s)));
      },
      displayRows() {
        return this.filter ? this.filterTable.length : this.totalRows;
      },
    },
    mounted() {
      this.getModules();
      this.getAllPaymentsList();
      this.getOwnerUsers();
      this.getBuildings();
      this.getHouses();
      this.getTenants();
      this.$on("AfterComplete", () => {
        this.getAllPaymentsList();
      });
    },
    methods: {
      getTenantName(item) {
        if (item.tenant && item.tenant.fullName) return item.tenant.fullName;
        return 'N/A';
      },
      getBuildingName(item) {
        if (item.house) {
          if (item.house.buildingName) return item.house.buildingName;
          if (item.house.building && item.house.building.buildingName) return item.house.building.buildingName;
        }
        return 'N/A';
      },
      getHouseInfo(item) {
        if (item.house) return (item.house.floor || '') + ' - ' + (item.house.roomNumber || '');
        return 'N/A';
      },
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        try {
          return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
        } catch (e) { return dateString; }
      },
      numberWithCommas(x) {
        if (x !== null && x !== undefined && x !== '') {
          var num = parseFloat(x);
          if (!isNaN(num)) return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return x;
        }
        return '0.00';
      },
      buildPayload(page) {
        const payload = { page: page || this.currentPage, line: this.perPage };
        if (this.filters.buildingId !== null) payload.buildingId = this.filters.buildingId;
        if (this.filters.houseId !== null) payload.houseId = this.filters.houseId;
        if (this.filters.tenantId !== null) payload.tenantId = this.filters.tenantId;
        if (this.filters.userId !== null) payload.userId = this.filters.userId;
        if (this.filters.paymentDate) payload.paymentDate = this.filters.paymentDate;
        if (this.filters.paymentMethod) payload.paymentMethod = this.filters.paymentMethod;
        if (this.filters.paymentCategory) payload.paymentCategory = this.filters.paymentCategory;
        if (this.filters.paymentForMonth) payload.paymentForMonth = this.filters.paymentForMonth;
        if (this.filters.transactionRef) payload.transactionRef = this.filters.transactionRef;
        if (this.filters.minAmount !== null) payload.minAmount = this.filters.minAmount;
        if (this.filters.maxAmount !== null) payload.maxAmount = this.filters.maxAmount;
        return payload;
      },
      getBuildings() {
        this.$store.dispatch('getAllBuildingsList', {})
          .then(response => {
            Array.from(response.data).forEach(b => {
              this.buildingOptions.push({ value: b.buildingId, text: b.buildingName });
            });
          })
          .catch(error => { console.log(error); });
      },
      getHouses() {
        this.$store.dispatch('getAllHouseList', { page: 1, line: 1000 })
          .then(response => {
            const list = (response.data.Contents || response.data || []);
            Array.from(list).forEach(h => {
              const buildingName = h.building ? h.building.buildingName : '';
              const label = (buildingName ? buildingName + ' - ' : '') + (h.floor || '') + ' ' + (h.roomNumber || '');
              this.houseOptions.push({ value: h.houseId, text: label.trim() });
            });
          })
          .catch(error => { console.log(error); });
      },
      getTenants() {
        this.$store.dispatch('getAllTenantList', { page: 1, line: 1000 })
          .then(response => {
            const list = (response.data.Contents || response.data || []);
            Array.from(list).forEach(t => {
              this.tenantOptions.push({ value: t.tenantId, text: t.fullName + (t.phoneNumber ? ' (' + t.phoneNumber + ')' : '') });
            });
          })
          .catch(error => { console.log(error); });
      },
      getOwnerUsers() {
        this.$store.dispatch('getAllOwnerUsers')
          .then(response => {
            Array.from(response.data).forEach(user => {
              this.ownerUserOptions.push({ value: user.id, text: user.fullName + ' (' + user.username + ')' });
            });
          })
          .catch(error => { console.log(error); });
      },
      getModules() {
        this.$store.dispatch('getModulesPermission', { userId: sessionStorage.getItem('userID') })
          .then(response => {
            var mod = response.data.modules.filter(x => x.name === 'PaymentSuper');
            if (mod.length > 0) {
              this.modulePermission.view = mod[0].listData || 0;
              this.modulePermission.create = mod[0].createData || 0;
              this.modulePermission.update = mod[0].updateData || 0;
              this.modulePermission.delete = mod[0].deleteData || 0;
            }
          })
          .catch(error => { console.log(error); });
      },
      fetchAllForSearch() {
        if (!this.totalRows) return;
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllPaymentsList', payload)
          .then(response => { this.allItems = response.data.Contents || []; })
          .catch(error => { console.log('Error fetching all for search:', error); });
      },
      getAllPaymentsList() {
        this.spinner = true;
        this.allItems = [];
        this.$store.dispatch('getAllPaymentsList', this.buildPayload())
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
            if (this.filter && this.filter.trim()) this.fetchAllForSearch();
          })
          .catch(error => { console.log('Error fetching payments:', error); })
          .finally(() => { this.spinner = false; });
      },
      applyFilters() {
        this.currentPage = 1;
        this.getAllPaymentsList();
      },
      resetFilters() {
        this.filters.buildingId = null;
        this.filters.houseId = null;
        this.filters.tenantId = null;
        this.filters.userId = null;
        this.filters.paymentDate = '';
        this.filters.paymentMethod = null;
        this.filters.paymentCategory = null;
        this.filters.paymentForMonth = '';
        this.filters.transactionRef = '';
        this.filters.minAmount = null;
        this.filters.maxAmount = null;
        this.filter = '';
        this.allItems = [];
        this.currentPage = 1;
        this.getAllPaymentsList();
      },
      changePage(event, page) {
        this.currentPage = page;
        this.spinner = true;
        this.$store.dispatch('getAllPaymentsList', this.buildPayload(page))
          .then(response => {
            this.items = response.data.Contents || [];
            this.totalRows = response.data.totalElements || 0;
          })
          .catch(error => { console.log('Error fetching payments:', error); })
          .finally(() => { this.spinner = false; });
      },
      changePerPage() {
        this.currentPage = 1;
        this.getAllPaymentsList();
      },
      fetchAllAndExport(format) {
        if (!this.totalRows) {
          this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
          return;
        }
        const payload = this.buildPayload();
        payload.page = 1;
        payload.line = this.totalRows;
        this.$store.dispatch('getAllPaymentsList', payload)
          .then(response => {
            const all = response.data.Contents || [];
            if (!all.length) {
              this.$notifications.notify({ message: 'No data to export.', horizontalAlign: 'center', verticalAlign: 'top', type: 'warning' });
              return;
            }
            if (format === 'excel') this.doExportExcel(all);
            else this.doExportPDF(all);
          })
          .catch(error => { console.log('Export error:', error); });
      },
      getDataForExcel() { this.fetchAllAndExport('excel'); },
      getDataForPDF()   { this.fetchAllAndExport('pdf'); },
      doExportExcel(all) {
        const data = all.map((item, i) => ({
          'No.': i + 1,
          'Tenant': this.getTenantName(item),
          'Tenant Phone No': item.tenantPhoneNumber || 'N/A',
          'Building': this.getBuildingName(item),
          'House': this.getHouseInfo(item),
          'Total Amount': this.numberWithCommas(item.totalAmount),
          'Paid Amount': this.numberWithCommas(item.payedAmount),
          '15% VAT': item.paymentCategory === 'Rent Payment' ? this.numberWithCommas(item.vat) : '0.00',
          '3% Withholding': this.numberWithCommas(item.withHolding),
          'Paid For': item.paymentCategory || 'N/A',
          'Paid Month': item.paymentForMonth || 'N/A',
          'Payment Method': item.paymentMethod || 'N/A',
          'Date of Payment': this.formatDate(item.paymentDate),
          'Credit Account': item.creditAccount || 'N/A',
          'Transaction Reference': item.transactionRef || 'N/A'
        }));
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Payments');
        XLSX.writeFile(wb, 'Payments.xlsx');
      },
      doExportPDF(all) {
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.text('Payments List', 14, 14);
        const rows = all.map((item, i) => [
          i + 1,
          this.getTenantName(item),
          item.tenantPhoneNumber || 'N/A',
          this.getBuildingName(item),
          this.getHouseInfo(item),
          this.numberWithCommas(item.totalAmount),
          this.numberWithCommas(item.payedAmount),
          item.paymentCategory === 'Rent Payment' ? this.numberWithCommas(item.vat) : '0.00',
          this.numberWithCommas(item.withHolding),
          item.paymentCategory || 'N/A',
          item.paymentForMonth || 'N/A',
          item.paymentMethod || 'N/A',
          this.formatDate(item.paymentDate),
          item.creditAccount || 'N/A',
          item.transactionRef || 'N/A'
        ]);
        doc.autoTable({
          head: [['No.','Tenant','Tenant Phone No','Building','House','Total Amount','Paid Amount','15% VAT','3% Withholding','Paid For','Paid Month','Payment Method','Date of Payment','Credit Account','Transaction Reference']],
          body: rows,
          startY: 20,
          styles: { fontSize: 7 }
        });
        doc.save('Payments.pdf');
      },
      handleError(error) {
        this.$notifications.notify({
          message: error.response ? error.response.data : error,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
        console.log(error);
      },
      clearData() {
        this.$emit('AfterComplete');
      }
    }
  }
</script>

<style scoped>
.table-container {
  overflow: auto;
}
.pagination-container {
  position: relative;
  z-index: 1;
  background: #fff;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
</style>